import { render, staticRenderFns } from "./Assign.vue?vue&type=template&id=e032e358&scoped=true"
import script from "./Assign.vue?vue&type=script&lang=js"
export * from "./Assign.vue?vue&type=script&lang=js"
import style0 from "./Assign.vue?vue&type=style&index=0&id=e032e358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e032e358",
  null
  
)

export default component.exports